export default __webpack_public_path__ + "708d45eb1e564862fc07d7845b3d688cd24e60f2fc5e8f244967ac7d7dcf2192.svg";